export default __webpack_public_path__ + "assets/images/81bfa8c47f379e47dc9bf79df2de64e1.png";